import { connect } from 'react-redux';
import TeamInvitationsPage from '../TeamInvitationsPage';
import { checkPermission, checkPlanPermission, googleTagManager } from '../../../utils/ProfileHelpers';
import {
  setAction,
  getInvitationsAction,
  deleteInvitationsAction,
  deleteInvitationAction,
  resendInvitationAction,
  getPlanDetailsAction,
  setInvitationsAction,
} from '../actions/teamInvitationsPage';
import { getInvites } from '../selectors/teamInvitations';

const mapStateToProps = (state) => {
  return {
    paths: state.app.paths || {},
    team: state.profile.team,
    groups: state.profile.groups,
    division: state.profile.division,
    divisions: state.profile.divisions,
    modalIsOpen: state.teamInvitationsPage.modalIsOpen,
    invitations: getInvites(state),
    form: state.teamInvitationsPage.form,
    emailText: state.teamInvitationsPage.emailText,
    inviteError: state.teamInvitationsPage.inviteError,
    resend: state.teamInvitationsPage.resend,
    showCancelInvitation: state.teamInvitationsPage.showCancelInvitation,
    currentInvitation: state.teamInvitationsPage.currentInvitation,
    groupId: state.teamInvitationsPage.groupId,
    priceTotal: state.teamInvitationsPage.priceTotal,
    unitPrice: state.teamInvitationsPage.unitPrice,
    inviteId: state.teamInvitationsPage.inviteId,
    page: state.teamInvitationsPage.page,
    pageSize: state.teamInvitationsPage.pageSize,
    pageCount: state.teamInvitationsPage.pageCount,
    dataReturned: state.teamInvitationsPage.dataReturned,
    subscription: state.profile.subscription,
    members: state.teamMembersPage.members,
    checkPermission: (permission) => checkPermission(permission, state.profile),
    checkPlanPermission: (permission) => checkPlanPermission(permission, state.profile),
    googleTagManager: googleTagManager,
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadInvitations: (team) => dispatch(getInvitationsAction({ team })),
  deleteInvitation: (team, inviteId, config) => dispatch(deleteInvitationAction({ team, inviteId, config })),
  deleteInvitations: (team, invites, config) => dispatch(deleteInvitationsAction({ team, invites, config })),
  resendInvite: (team, invitation) => dispatch(resendInvitationAction({ team, invitation })),
  getPlanDetails: (team, config) => dispatch(getPlanDetailsAction({ team, config })),
  saveInvitations: (team, division, emailText, groupId, config) =>
    dispatch(setInvitationsAction({ team, division, emailText, groupId, config })),
  set: (params) => dispatch(setAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TeamInvitationsPage);
